import { useRef, useState } from 'react';
import api from '../api/api';
import './PhotoCapture.css';

export default function PhotoCapture({ entry, logbook, onClose }) {
  const [photos, setPhotos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const handleCapture = (e) => {
    const files = Array.from(e.target.files);
    const newPhotos = files.map(file => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setPhotos(prev => [...prev, ...newPhotos]);
  };

  const handleRemove = (idx) => {
    setPhotos(prev => prev.filter((_, i) => i !== idx));
  };

  const handleUpload = async () => {
    if (photos.length === 0) return;
    setUploading(true);
    setError('');

    try {
      for (let i = 0; i < photos.length; i++) {
        const formData = new FormData();
        formData.append('photo', photos[i].file);
        formData.append('order_identifier', entry.order_identifier || entry.logbook_identifier || 'egyeb');
        formData.append('category', entry.category === 'pickup' ? 'Felrakó' : 'Lerakó');
        formData.append('sequence', String(i + 1));

        await api.post('upload-photo/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      setUploaded(true);
      setTimeout(() => onClose(), 1500);
    } catch {
      setError('Nem sikerült feltölteni a képeket.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box photo-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className="ti ti-camera"></i> Fotók</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="ti ti-x"></i>
          </button>
        </div>

        <div className="modal-body">
          {/* Fotók előnézete */}
          {photos.length > 0 && (
            <div className="photo-grid">
              {photos.map((p, idx) => (
                <div className="photo-thumb" key={idx}>
                  <img src={p.preview} alt={`Fotó ${idx + 1}`} />
                  <button className="photo-remove" onClick={() => handleRemove(idx)}>
                    <i className="ti ti-x"></i>
                  </button>
                </div>
              ))}
            </div>
          )}

          {uploaded && (
            <div className="upload-success">
              <i className="ti ti-circle-check"></i> Sikeresen feltöltve!
            </div>
          )}

          {error && <p className="modal-error">{error}</p>}
        </div>

        <div className="modal-footer" style={{ flexDirection: 'column', gap: 10 }}>
          {/* Kamera gomb */}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            multiple
            style={{ display: 'none' }}
            onChange={handleCapture}
          />
          <button
            className="btn-primary"
            onClick={() => fileInputRef.current.click()}
            disabled={uploading}
          >
            <i className="ti ti-camera"></i> + Fotó készítése
          </button>

          {/* Küldés gomb */}
          {photos.length > 0 && (
            <button
              className="btn-primary btn-upload"
              onClick={handleUpload}
              disabled={uploading}
            >
              {uploading
                ? 'Feltöltés...'
                : `Küldés (${photos.length} fotó)`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}